import { TypeaheadDropdownContent } from 'components/FormikTypeaheadInput/TypeaheadDropdownContent';
import type { GraphPathLookupIpOption } from 'components/Graph/GraphSidePanel/GraphPathlookup/GraphPathLookupIpOption';
import type { FormikProps } from 'formik';
import type { JSX } from 'react';

interface DropdownMenuProps<TFormValues> {
  data: GraphPathLookupIpOption[] | null;
  name: keyof TFormValues & string;
  formik: FormikProps<TFormValues>;
  withDns?: boolean;
}

export const PathLookupDropdownMenu = <TFormValues,>(
  props: DropdownMenuProps<TFormValues>,
): JSX.Element => {
  const handleIpSelect = ({ ip }: GraphPathLookupIpOption) => {
    props.formik.setFieldValue(props.name, ip);
  };

  const withDns = props.withDns ?? true;

  // When there are no results yet (null) or empty, delegate to a single instance for correct empty state.
  if (!props.data?.length) {
    return (
      <TypeaheadDropdownContent
        options={props.data ?? null}
        onSelect={handleIpSelect}
        renderOption={({ ip }) => ip}
      />
    );
  }

  const aimItems = props.data.filter(
    (item) => item.aimWorkloadName || item.aimApplicationName,
  );
  const regularItems = props.data.filter(
    (item) => !item.aimWorkloadName && !item.aimApplicationName,
  );

  return (
    <>
      {aimItems.length > 0 && (
        <TypeaheadDropdownContent
          options={aimItems}
          onSelect={handleIpSelect}
          title='IP Address / Application / Workload'
          renderOption={({ ip, aimApplicationName, aimWorkloadName }) =>
            `${ip} / ${aimApplicationName ?? '-'} / ${aimWorkloadName ?? '-'}`
          }
        />
      )}
      {regularItems.length > 0 && (
        <TypeaheadDropdownContent
          options={regularItems}
          onSelect={handleIpSelect}
          title={withDns ? 'IP Address / DNS' : 'IP Address'}
          renderOption={({ ip, dnsName }) =>
            dnsName ? `${ip} / ${dnsName}` : ip
          }
        />
      )}
    </>
  );
};
